/* eslint @typescript-eslint/strict-boolean-expressions: off */

import React from "react";
import { Loading } from "src/components/loading/loading";
import { logger } from "src/utils/logger/browser";
import { useRouter } from "next/router";
import { useLoginUrl } from "src/hooks/useLoginUrl";

export interface RedirectProps {
  href: string;
  replace?: boolean;
}

export const Redirect: React.FC<RedirectProps> = (props) => {
  const { replace, push } = useRouter();
  const external = !props.href.startsWith("/");

  React.useEffect(() => {
    if (props.replace && external) {
      // Replace with an external link.
      window.location.replace(props.href);
    } else if (props.replace) {
      // Replace with an internal link.
      replace(props.href).catch(logger.error);
    } else if (external) {
      // Redirect to an external link.
      window.location.href = props.href;
    } else {
      // Redirect to an internal link.
      push(props.href).catch(logger.error);
    }
  }, [props.href, external]);

  return <Loading />;
};

export const RedirectLogin: React.FC = () => {
  const loginUrl = useLoginUrl();

  return <Redirect href={loginUrl} />;
};
